import { MagnifyingGlass, SlidersHorizontal } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const SelectFilter = ({ testId, value, onChange, options, allLabel, allOptionTestId, optionTestId }) => (
  <select
    data-testid={testId}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    className="h-12 rounded-md border border-zinc-300 bg-white px-3 text-sm font-bold outline-none transition-[border-color,box-shadow] duration-200 focus:border-[#0055FF] focus:ring-1 focus:ring-[#0055FF]"
  >
    <option data-testid={allOptionTestId} value="">{allLabel}</option>
    {options.map((option) => (
      <option data-testid={optionTestId(option)} key={option} value={option}>
        {option}
      </option>
    ))}
  </select>
);

const SearchInput = ({ value, onChange }) => (
  <label data-testid="search-field-label" className="relative block">
    <MagnifyingGlass className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[#52525B]" size={20} weight="bold" />
    <input
      data-testid="search-input"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Search facility, city, or address"
      className="h-12 w-full rounded-md border border-zinc-300 bg-white pl-10 pr-3 text-sm font-semibold outline-none transition-[border-color,box-shadow] duration-200 focus:border-[#0055FF] focus:ring-1 focus:ring-[#0055FF]"
    />
  </label>
);

export const FiltersBar = ({ filters, setFilters, states, services, onClear }) => {
  const updateFilter = (key, value) => setFilters((current) => ({ ...current, [key]: value }));

  return (
    <section data-testid="filters-bar" className="border-b border-zinc-200 bg-white px-4 py-4 sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-3 lg:grid-cols-[1fr_140px_190px_150px_auto]">
        <SearchInput value={filters.q} onChange={(value) => updateFilter("q", value)} />
        <SelectFilter
          testId="state-filter-select"
          value={filters.state}
          onChange={(value) => updateFilter("state", value)}
          options={states}
          allLabel="All states"
          allOptionTestId="state-filter-option-all"
          optionTestId={(state) => `state-filter-option-${state}`}
        />
        <SelectFilter
          testId="service-filter-select"
          value={filters.service}
          onChange={(value) => updateFilter("service", value)}
          options={services}
          allLabel="All services"
          allOptionTestId="service-filter-option-all"
          optionTestId={(service) => `service-filter-option-${service.toLowerCase().replaceAll(" ", "-")}`}
        />
        <select
          data-testid="rating-filter-select"
          value={filters.min_rating}
          onChange={(event) => updateFilter("min_rating", event.target.value)}
          className="h-12 rounded-md border border-zinc-300 bg-white px-3 text-sm font-bold outline-none transition-[border-color,box-shadow] duration-200 focus:border-[#0055FF] focus:ring-1 focus:ring-[#0055FF]"
        >
          <option data-testid="rating-filter-option-all" value="">Any rating</option>
          <option data-testid="rating-filter-option-4" value="4">4+ stars</option>
          <option data-testid="rating-filter-option-5" value="5">5 stars</option>
        </select>

        <Button
          data-testid="clear-filters-button"
          type="button"
          onClick={onClear}
          className="h-12 rounded-md border border-zinc-300 bg-[#09090B] px-4 text-sm font-black text-white transition-colors duration-200 hover:bg-[#0055FF]"
        >
          <SlidersHorizontal data-testid="clear-filters-icon" size={18} weight="bold" /> Reset
        </Button>
      </div>
    </section>
  );
};